import { createRef, Component } from "react";

import { pazienHistory } from "common/components/pazienHistory";

export class CreateBuDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true
        };
        this.childRef = createRef();
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (this.state.collapsed) {
            document.removeEventListener("mousedown", this.collapseDropdownOnClickOutside);
        } else {
            document.addEventListener("mousedown", this.collapseDropdownOnClickOutside);
        }
    }
    
    componentWillUnmount() {
        if (!this.state.collapsed) {
            document.removeEventListener("mousedown", this.collapseDropdownOnClickOutside);
        }
    }
    
    expandDropdown = () => {
        this.setState({
            collapsed: false
        });
    };
    
    collapseDropdown = () => {
        this.setState({
            collapsed: true
        });
    };
    
    collapseDropdownOnClickOutside = (event) => {
        if (this.childRef && this.childRef.current && !this.childRef.current.contains(event.target)) {
            this.collapseDropdown();
        }
    };
    
    navigateToBuManager = () => {
        this.collapseDropdown();
        pazienHistory.navigateWithParams("preferences/bumanager/unmapped", {
            trigger: true
        });
    };
    
    render() {
        if (this.state.collapsed) {
            return (
                <div className="noBuDropdown-chevron" onClick={this.expandDropdown}>
                    <span><i className="fas fa-chevron-down"/></span>
                </div>
            );
        }
        
        return (
            <div>
                <div className="noBuDropdown-chevron" onClick={this.collapseDropdown}>
                    <span><i className="fas fa-chevron-up"/></span>
                </div>
                
                <div className="noBuDropdown" ref={this.childRef}>
                    Visit the <a href="#" onClick={this.navigateToBuManager}>business unit manager</a> to group your MIDs into business units
                </div>
            </div>
        );
    }
}
